import React, { useState } from "react";
import { useModalEsc, backdropClose } from "../utils/modalStack";

export default function DeleteConfirmModal({
  title,
  message,
  requireText = "HAPUS",
  confirmLabel = "Hapus",
  onConfirm,
  onClose,
}) {
  const [text, setText] = useState("");
  useModalEsc(onClose);

  const ok = text.trim().toLowerCase() === requireText.toLowerCase();

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onMouseDown={backdropClose(onClose)}>
      <div className="modal-box" onMouseDown={(e) => e.stopPropagation()}>
        <h2 className="modal-title">{title}</h2>
        <div className="page-sub" style={{ marginBottom: "var(--gap-lg)" }}>{message}</div>
        <div className="form-row">
          <label className="form-label" htmlFor="delete-confirm-gate-text">Ketik <b>{requireText}</b> untuk konfirmasi</label>
          <input id="delete-confirm-gate-text" className="form-input" value={text} autoFocus
            placeholder={requireText} onChange={(e) => setText(e.target.value)} />
        </div>
        <div className="modal-actions">
          <button type="button" className="btn" onClick={onClose}>Batal</button>
          <button type="button" className="btn btn-danger" disabled={!ok}
            onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
